import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';
import tools from '../tools/tools.js';
import programsMarkup from '../markup2/programmsFest_body.js';
import programsMarkupList from '../markup2/universalListOfDataBody.js';
import toolsMarkup from '../markup/tools.js';
import CardAddMarkup from '../markup2/programmsFest_filmsList.js';
// import CardAddMarkup from '../markup/reference_programmsFest_films_list_body.js';

import filmsWithoutMarkup from '../markup2/filmsWithoutProgramms.js';

import filmApplicationsForConsider from '../lk/filmApplicationsForConsider.js';
import makePDF from '../lk/filmExportPDF.js';

import scheduleJS from './schedule.js';

// import programsMarkup  filmprograms.js

const loaderSpinnerId = 'loader-enterprises';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);

const view = document.querySelector('#programmsFest');
const arrayGroups = view.querySelector('.groupsOfConsider');

const listprogrammsFestAddBt = view.querySelector('div[name=navigation]').querySelector('button[name=add');
const listprogrammsFestRefreshBt = view.querySelector('div[name=navigation]').querySelector('button[name=refresh');

const listprogrammsFestExportPDFBt = view.querySelector('div[name=navigation]').querySelector('button[name=exportPDF');

const mainTabPaneBTDataDisplay = view.querySelector('button[name=typeDataDisplay]');
const mainTabPaneBTDataSort = view.querySelector('button[name=typeDataSort]');
const selectTimeZone = view.querySelector('select[name=listTimeZone]');


const formProgrammCard = document.querySelector('#formProgrammCard');
const cardProgrammName = formProgrammCard.querySelector('input[name=name]');

const colorHex = formProgrammCard.querySelector('input[name=colorHex]');
const colorHexDisplay = formProgrammCard.querySelector('div[name=colorHexDisplay]');
const orderProgramm = formProgrammCard.querySelector('select[name=order]');
const cardHeader = formProgrammCard.querySelector('h5[name=header]');
const cardProgrammSubmit = formProgrammCard.querySelector('button[name=submit]');
const cardProgrammParent = formProgrammCard.querySelector('select[name=parent]');
const cardProgrammType = formProgrammCard.querySelector('select[name=type]');
const cardProgrammCanVote = formProgrammCard.querySelector('select[name=canVote]');

const cardSearchAddFilm = document.querySelector('#catalog_films_in_programs_add');
const cardSearchAddFilmSearchField = cardSearchAddFilm.querySelector('#catalog_films_in_programs_add-txt');
const cardSearchAddFilmSearchBt = cardSearchAddFilm.querySelector('#catalog_films_in_programs_add-submit');
const cardSearchAddFilmSwitherFree = cardSearchAddFilm.querySelector('input[name=onlyFree]');

const cardOne = document.querySelector('#program_card');

const programBody = document.querySelector('#programmsFest-body');

let currentGroup = -1;



mainTabPaneBTDataSort.addEventListener('click', function () {
  // 0 - сортировка по номеру 
  // 1 - сортировка по алфавиту

  let typeDataSort = mainTabPaneBTDataSort.value;
  mainTabPaneBTDataSort.classList.remove(`iconDataSort${typeDataSort}`);

  ++typeDataSort;
  if (typeDataSort === 2)
    typeDataSort = -1;

  mainTabPaneBTDataSort.value = typeDataSort;
  mainTabPaneBTDataSort.classList.add(`iconDataSort${typeDataSort}`);
  
  reDisplayMainTable();
});

mainTabPaneBTDataDisplay.addEventListener('click', function () {
  // 0 - список
  // 1 - иконки
  // alert();
  let typeDataDisplay = mainTabPaneBTDataDisplay.value;
  mainTabPaneBTDataDisplay.classList.remove(`iconDataDisplay${typeDataDisplay}`);

  ++typeDataDisplay;
  if (typeDataDisplay === 2)
    typeDataDisplay = -1;

  mainTabPaneBTDataDisplay.value = typeDataDisplay;
  mainTabPaneBTDataDisplay.classList.add(`iconDataDisplay${typeDataDisplay}`);
  
  reDisplayMainTable();
});


// ПИКЕР ПАПОК  
arrayGroups.addEventListener('click', function (evt) {
    if (evt.target.attributes.value) {
  	  currentGroup = parseInt(evt.target.attributes.value.nodeValue, 10);
      if (currentGroup === 0)
      	currentGroup = parseInt(arrayGroups.querySelector('i[parentForSelect=true]').querySelector('select').value);

      if (currentGroup < 98) 
        reDisplayMainTable();
      else 
			 reDisplayFilmsWithoutPrograms();
    }

    arrayGroups.querySelectorAll('.considerGroup').forEach((element) => {
      if ((currentGroup === parseInt(element.attributes.value.nodeValue, 10) && allPrograms.length < 3) ||
       (allPrograms.length > 2 && currentGroup > 1 && currentGroup < 90 && parseInt(element.attributes.value.nodeValue, 10) === 0))
        element.classList.add('active'); 
      else
        element.classList.remove('active');
   });
});

function addEventListenerForDinamycSelect() {
	arrayGroups.querySelector('i[parentForSelect=true]').querySelector('select').addEventListener('change', function (evt) {
		currentGroup = arrayGroups.querySelector('i[parentForSelect=true]').querySelector('select').value;
		console.log(currentGroup);

		reDisplayMainTable();

		arrayGroups.querySelectorAll('.considerGroup').forEach((element) => {
      if ((currentGroup === parseInt(element.attributes.value.nodeValue, 10) && allPrograms.length < 3) ||
       (allPrograms.length > 2 && currentGroup > 1 && currentGroup < 90 && parseInt(element.attributes.value.nodeValue, 10) === 0))
        element.classList.add('active'); 
      else
        element.classList.remove('active');
   });

	});

	arrayGroups.querySelector('button[nameAction=edit]').addEventListener('click',(evt) => {
		openCardProgrammEdit(arrayGroups.querySelector('i[parentForSelect=true]').querySelector('select').value);
	});

}


 // ОБАРБОТЧИК НА ВСЕ КНОПКИ
programBody.addEventListener('click', function (evt) {
	// console.log('click');
	programBodyClick(evt);
});

function programBodyClick (evt) {
	if (evt.target.attributes.name) {
    	let nameAction = evt.target.attributes.name.nodeValue;
    	// console.log(nameAction);
    	if (nameAction === 'editProgram') 
    		openCardProgrammEdit(evt.target.attributes.blockid.nodeValue);
			else if(nameAction === 'addFilmInProgramm') {
    		cardSearchAddFilmSwitherFree.checked = false;
		    curProgramID = evt.target.attributes.programid.nodeValue;
		    searchFilmsInList();
		    $(cardSearchAddFilm).modal('show');
    	} else if (nameAction === 'hideNshow'){
    		// console.log(evt.target.parentNode.parentNode.parentNode.parentNode.parentNode.children[2].classList.contains('d-none'));
    		if (evt.target.parentNode.parentNode.parentNode.parentNode.parentNode.children[2].classList.contains('d-none')){
    			evt.target.parentNode.parentNode.parentNode.parentNode.parentNode.children[1].classList.remove('d-none')
    			evt.target.parentNode.parentNode.parentNode.parentNode.parentNode.children[2].classList.remove('d-none')
    		}   else{
    			evt.target.parentNode.parentNode.parentNode.parentNode.parentNode.children[1].classList.add('d-none')
    			evt.target.parentNode.parentNode.parentNode.parentNode.parentNode.children[2].classList.add('d-none')
    		}
    	} else if(nameAction === 'moveUp' || nameAction === 'moveDown'){
    		// console.log(evt.target.attributes);
    		xhr.request = {
		        metod: 'PUT',
		        url: `filmPrograms/${evt.target.attributes.programID.nodeValue}/film/${evt.target.attributes.filmID.nodeValue}`,
		        data: `action=${nameAction}`,
		        callbackSuccess: onSuccessLoadAllData
		    };
    	}
    	// alert('dfg');
  	} else if(evt.target.attributes.fcid)
  		filmApplicationsForConsider.loadRequestFilmApplication(evt.target.attributes.fcid.nodeValue);
  	else if (evt.target.attributes.programid) {
  		allPrograms.forEach((pElement) => {
			if (parseInt(pElement.id, 10) === parseInt(evt.target.attributes.programid.nodeValue,10)){
				let arrWithOneElement = [];
				arrWithOneElement.push(pElement);
		  		programsMarkup.drawDataInContainer(arrWithOneElement, allFilms, allProgramsHideNseekMemory, true);
			}
		});
  	} else if(evt.target.attributes.operation){
    	let nameAction = evt.target.attributes.operation.nodeValue;
    	if (nameAction === 'closeOneProgram') 
	  		reDisplayMainTable();
  	}
  	// else if(){

  	// }
}


cardOne.addEventListener('click', function (evt) {

		if (evt.target.attributes.name &&
 			 (evt.target.attributes.name.nodeValue === 'addFilmInProgramm' ||  evt.target.attributes.name.nodeValue === 'editProgram')) 
		{
			if(!allFilms || allFilms.length  == 0)
				loadListFilms()
		 	$(cardOne).modal('hide');
		 	setTimeout(function() { 
		 	  searchFilmsInList();
		    $(cardSearchAddFilm).modal('show');
      },500);

		} else if( evt.target.attributes.name  && (evt.target.attributes.name.nodeValue === 'moveUp' || evt.target.attributes.name.nodeValue === 'moveDown')){
			
					xhr.request = {
		        metod: 'PUT',
		        url: `filmPrograms/${curProgramID}/film/${evt.target.attributes.filmID.nodeValue}`,
		        data: `action=${evt.target.attributes.name.nodeValue}&return=single`,
		        callbackSuccess: (servarAnswer) => {
						  if (servarAnswer.status === 200){
							 	programsMarkup.drawDataInOneCard(servarAnswer.data);
							 	scheduleJS.publicReloadPrograms();
							}
						}
		    };
		}
})

function openCardProgrammEdit(programID) {

		let selectProgramInfo = false;

		allPrograms.forEach((pElement) => {
			if (parseInt(pElement.id, 10) === parseInt(programID,10))
				selectProgramInfo = pElement;

		});

		console.log(selectProgramInfo);


		cardProgrammName.value = selectProgramInfo.name;
		curProgramID = selectProgramInfo.id;
		orderProgramm.value = selectProgramInfo.order;
		cardProgrammType.value = selectProgramInfo.prType;
		cardProgrammParent.value = selectProgramInfo.parent;
		cardProgrammCanVote.value = selectProgramInfo.canVote;

    cardProgrammParentValidBlock();

		tools.removeOptions(orderProgramm);
		for (let i = 1; i < 16; i++) {
		  	let opt = document.createElement('option');
		 	 opt.value = i;
		 // console.log(dataForSource.data[i].city_name);
		  	opt.innerHTML = i ;
		  	if(i === selectProgramInfo.order)
		  		opt.selected = true;
		  	orderProgramm.appendChild(opt);
		}

		colorHexDisplay.classList.remove('notCorrect');
		colorHexDisplay.innerHTML = '';
		colorHexDisplay.style.backgroundColor = `#${selectProgramInfo.color}`;
		colorHex.value = selectProgramInfo.color;
		cardHeader.innerHTML = 'Редактирование программы';
		validCardProgramm();

    $(formProgrammCard).modal('show');
}


// Кнопка создания новой карточки

let curProgramID = false;

listprogrammsFestAddBt.addEventListener('click', function () {
	cardProgrammName.value = '';
	curProgramID = false;
	tools.removeOptions(orderProgramm);
	for (let i = 1; i < 16; i++) {
	  let opt = document.createElement('option');
	  opt.value = i;
	 // console.log(dataForSource.data[i].city_name);
	  opt.innerHTML = i ;
	  orderProgramm.appendChild(opt);
	}
	
	colorHexDisplay.classList.remove('notCorrect');
	colorHexDisplay.innerHTML = '';
	colorHexDisplay.style.backgroundColor = '#7F7FD5';
	colorHex.value = '7F7FD5';
	cardHeader.innerHTML = 'Создание программы';
	validCardProgramm();

   $(formProgrammCard).modal('show');
  // alert();
});
 // Работа логики всей карточки
colorHex.addEventListener('keyup', function (event) {
	if (colorHex.value.length === 6) {
		colorHexDisplay.innerHTML = '';
		colorHexDisplay.style.backgroundColor = '#' + colorHex.value;
		colorHexDisplay.classList.remove('notCorrect');
	} else {
		colorHexDisplay.classList.add('notCorrect');
		colorHexDisplay.innerHTML = 'ERROR!';
		colorHexDisplay.style.backgroundColor = '#fafafa';
	}
	validCardProgramm()

});

cardProgrammName.addEventListener('keyup', function (event) {
	validCardProgramm();
});

function validCardProgramm () {
	if (cardProgrammName.value.length > 3) {
		cardProgrammName.classList.remove('notCorrect');
		cardProgrammSubmit.disabled = false;
	} else {
		cardProgrammName.classList.add('notCorrect');
		cardProgrammSubmit.disabled = true;
	}

}
cardProgrammSubmit.addEventListener(('click') , function (){
	// отправка запроса на создание программы
	let dataQuery = `name=${encodeURIComponent(cardProgrammName.value)}&parent=${cardProgrammParent.value}&canVote=${cardProgrammCanVote.value ? cardProgrammCanVote.value : 0}&color=${colorHex.value}&order=${orderProgramm.value}`;
	if(curProgramID){
		 xhr.request = {
	        metod: 'PUT',
	        url: `filmPrograms/${curProgramID}`,
	        data: dataQuery,
	        callbackSuccess: onSuccessLoadAllFilmProgramms
	    };
	} else {
		 xhr.request = {
	        metod: 'POST',
	        url: 'filmPrograms',
	        data: dataQuery,
	        callbackSuccess: onSuccessLoadAllFilmProgramms
	    };
	}
	

});

const onSuccessLoadAllFilmProgramms = (servarAnswer) => {
    if (servarAnswer.status === 200) {
    	$(formProgrammCard).modal('hide');
    	loadListPrograms();
	}
};

listprogrammsFestRefreshBt.addEventListener(('click'),(evt) => {
	loadListPrograms();
});



let treePrograms = [];
const onSuccessLoadAllData = (servarAnswer) => {
	
		scheduleJS.publicReloadPrograms();

	if(allPrograms && allPrograms){
		let allHideNSeek = programBody.querySelectorAll('input[name=hideNshow]');
		allProgramsHideNseekMemory = [];
		allHideNSeek.forEach((aElement) => {
			if(aElement.checked)
				allProgramsHideNseekMemory.push(aElement.attributes.programid.nodeValue);
		});
	}

	treePrograms = [];
	allPrograms = [];
    if (servarAnswer.status === 200)
    	if(servarAnswer.data.programs);
    	allPrograms = servarAnswer.data.programs;
    

    //отображение дерева и его ветки


	if(allPrograms)
			allPrograms.forEach((pElement) => {
				if(!pElement.parent) 
	              recursionSearchChild(allPrograms, pElement.id,pElement.name , 0);
	     });

	arrayGroups.innerHTML = ` 
	                 <div class="considerGroup active" value="-1">
	                  Все  (<b id="countAll">11</b>)
	                </div>`;

	if (allPrograms && allPrograms.length > 3) {
		
		arrayGroups.innerHTML += `<div class="considerGroup  row w-60" valueInSelectChild =true value="0">
                  Программа: <i class="w-65 ml-3"  parentForSelect=true></i>
                  	<button class="btn btn-success p-0 icon-btn icon-btn__edit ml-auto" nameAction="edit"></button>
                  	<button class="btn btn-success p-0 icon-btn icon-btn__delete--red mr-1 ml-1"  nameAction="delete" ></button>
                </div>`; 
  let allChilds = document.createElement('select');
  let opt;
  allChilds.classList.add('w-100');

	  treePrograms.forEach((tElement) => {
			if (tElement.depth === 1)
			{
				opt = document.createElement('option');
				opt.value = tElement.id;
				opt.innerHTML = tElement.name; 
				// opt.disabled = true;
			  allChilds.appendChild(opt);
			}
		});


    arrayGroups.querySelector('i[parentForSelect=true]').appendChild(allChilds);
		setTimeout(function() { addEventListenerForDinamycSelect(); }, 1000);

	} else {
		if(allPrograms)
			allPrograms.forEach((pElement) => {
				if(!pElement.parent) 
						arrayGroups.innerHTML += `              
								  <div class="considerGroup" value="${pElement.id}">
	                 ${pElement.name} (<b id="countInProgram_${pElement.id}">0</b>)
	                </div>`;
			});

	}
	arrayGroups.innerHTML += `              
								  <div class="considerGroup ml-auto" value="99">
	                  Фильмы без программы (<b id="countWithoutPrograms">0</b>)
	                </div>`;



  tools.removeOptions(cardProgrammParent);
	let opt = document.createElement('option');
	opt.value = null;
	opt.innerHTML = 'Родительский элемент'; 
  cardProgrammParent.appendChild(opt);

	treePrograms.forEach((tElement) => {
		if (tElement.depth === 1)
		{
			opt = document.createElement('option');
			opt.value = null;
			opt.innerHTML = ' --- '; 
			opt.disabled = true;
		  cardProgrammParent.appendChild(opt);
		}

  	opt = document.createElement('option');
 	  opt.value = tElement.id;
 	  let htmlName = '';

		for (let i = 1; i < tElement.depth; i++) 
			htmlName += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
		if(tElement.depth > 1)
			htmlName +='&middot; ';
		htmlName +='  ';
		htmlName += tElement.name;
  	opt.innerHTML = htmlName;
  	cardProgrammParent.appendChild(opt);
			
	});

	reDisplayMainTable();

};

function recursionSearchChild(arrSearch, parentID, parentName, depth){
	++ depth;
	let pTreeElement =  new Object();
	pTreeElement['name'] = parentName;
	pTreeElement['id'] = parentID;
	pTreeElement['depth'] = depth;

	treePrograms.push(pTreeElement);

	arrSearch.forEach((aElement) => {
		if(aElement.parent === parentID)
			recursionSearchChild(arrSearch, aElement.id ,aElement.name, depth);
	});

	return pTreeElement;
}
cardProgrammParent.addEventListener('change', function (event) {
	cardProgrammParentValidBlock()
});

function cardProgrammParentValidBlock () {
	if(cardProgrammParent.value === null || cardProgrammParent.value === 'null'){
		formProgrammCard.querySelector('div[name=divBlockCategory]').classList.remove('divDisabled');
		formProgrammCard.querySelector('div[name=divBlockSuppotVotes]').classList.remove('divDisabled');
		formProgrammCard.querySelector('div[name=divBlockColor]').classList.add('divDisabled');	
	} else {
		formProgrammCard.querySelector('div[name=divBlockCategory]').classList.add('divDisabled');
		formProgrammCard.querySelector('div[name=divBlockSuppotVotes]').classList.add('divDisabled');
		formProgrammCard.querySelector('div[name=divBlockColor]').classList.remove('divDisabled');	
	}
}


cardProgrammType.addEventListener('change', function (event) {
	cardProgrammName.value = cardProgrammType.options[cardProgrammType.selectedIndex].text;
});

function loadListPrograms (){
	xhr.request = {
        metod: 'GET',
        url: 'filmPrograms',
        data: '',
        callbackSuccess: onSuccessLoadAllData
     };

}


function loadListFilms (){
	xhr.request = {
        metod: 'GET',
        // url: `festival/${auth.currentFestival}/fimlsInFestival`,
        url: `filmsInFestival/${auth.currentFestival}/`,
        data: '',
        callbackSuccess: onSuccessLoadFilms
     };
}


const onSuccessLoadFilms = (servarAnswer) => {
	allFilms = [];	
    if (servarAnswer.status === 200)
    	if(servarAnswer.data.films)
	    	allFilms = servarAnswer.data.films;

	loadListPrograms();
};

function reDisplayFilmsWithoutPrograms () {
	let allFilmsCopy = reDisplayFilmsWithoutProgramsCounter();
	filmsWithoutMarkup.drawDataInContainer(allFilmsCopy);
}
function  reDisplayFilmsWithoutProgramsCounter(){
	let allFilmsCopy = allFilms.slice();
	let newfilmsCopy = [];

	if(allPrograms && allFilmsCopy) {

		allFilmsCopy.forEach((filmElem) => {
			let wasInProgramm = false;
			allPrograms.forEach((pElement) => {
				if(pElement.films)
					pElement.films.forEach((fpElement) => {
							if(fpElement.filmIDfk === filmElem.id)
								wasInProgramm = true;
								// allFilmsCopy
					});
						
					
				
			});
			if(!wasInProgramm)
				newfilmsCopy.push(filmElem);
		});
	};

	view.querySelector('#countWithoutPrograms').innerHTML = newfilmsCopy.length;
	return newfilmsCopy;
};

function reDisplayMainTable() {
	// console.log('dfdf');
	reDisplayFilmsWithoutProgramsCounter();
	
	programsMarkup.drawMarkupInContainer(loaderSpinnerMarkup);

	let arrToDisplay = [];
	let countGlobalChildOnMainParents = 0;

	allPrograms.forEach((pElement) => {
		let countElementIntoGroup = 0;

		if (!pElement.parent) { 
			allPrograms.forEach((eElement)=> {
				if (pElement.id === eElement.parent) {
					++countElementIntoGroup;
					++countGlobalChildOnMainParents;
					if (parseInt(eElement.parent) ===  parseInt(currentGroup) || currentGroup === -1)
						arrToDisplay.push(eElement);
				}
			});
			  
			if (allPrograms.length < 3)
				view.querySelector(`#countInProgram_${pElement.id}`).innerHTML = countElementIntoGroup;
			
		}	
	});

	view.querySelector('#countAll').innerHTML = countGlobalChildOnMainParents;

	let arrDisplaySorted = [];
	if(mainTabPaneBTDataSort.value == -1) 
		arrDisplaySorted = arrToDisplay.sort(function(b, a) {
	        return parseInt(a.id, 10) - parseInt(b.id, 10);
	     });
	else if(mainTabPaneBTDataSort.value == 0) 
		arrDisplaySorted = arrToDisplay.sort(function(a, b) {
	        return parseInt(a.id, 10) - parseInt(b.id, 10);
	     }); 
	else
		arrDisplaySorted = arrToDisplay.sort(function(a, b) {
			if(a.name < b.name) { return -1; }
		    if(a.name > b.name) { return 1; }
		    return 0;
	     });

	if (mainTabPaneBTDataDisplay.value == 0) 
		programsMarkupList.drawDataInContaineInDIV(arrDisplaySorted, programBody, 'programID');
	else
	 	programsMarkup.drawDataInContainer(arrDisplaySorted, allPrograms, allFilms, allProgramsHideNseekMemory, false);

}
let allFilms = [];
let allPrograms = [];
let allProgramsHideNseekMemory = [];

// работа с окном добавления работы

cardSearchAddFilmSearchField.addEventListener('keyup', function (event) {
	searchFilmsInList();
});
cardSearchAddFilmSearchBt.addEventListener('click', function (evt3) {
  	searchFilmsInList();
});

function searchFilmsInList (){
 	let selectedData = [];
 	// console.log(item);
	allFilms.forEach((item) => {
		let cardSearchVAlue = '';
		if(cardSearchAddFilmSearchField.value){
			if ( typeof cardSearchAddFilmSearchField.value === 'string')
				cardSearchVAlue = cardSearchAddFilmSearchField.value.toLowerCase();
			else
				cardSearchVAlue = cardSearchAddFilmSearchField.value;

		}
		let lowerCaseString = '';
		if(typeof item.name === 'string' ){
			lowerCaseString = item.name.toLowerCase();
		}

	    if (item && lowerCaseString.indexOf(cardSearchVAlue) !== -1
	    	 || item.numRequest === parseInt(cardSearchVAlue)) {
	      selectedData.push(item);
	    }
	});

    let filmsInCurrentProgram = [];
	allPrograms.forEach((pElement) => {
		if(parseInt(pElement.id, 10) === parseInt(curProgramID, 10))
			if(pElement.films)
				filmsInCurrentProgram = pElement.films.slice();
	});

	let arrFilmsWithoutProgram = reDisplayFilmsWithoutProgramsCounter();
	CardAddMarkup.drawDataInContainer(selectedData, filmsInCurrentProgram, arrFilmsWithoutProgram , cardSearchAddFilmSwitherFree.checked);

 }

cardSearchAddFilm.addEventListener('click', function (evt) {
	// console.log(evt.target.classList);

	if (evt.target.attributes.name) {
    	let nameAction = evt.target.attributes.name.nodeValue;
    	if (nameAction === 'programFilmLinkAction') {
    		// console.log(evt.target.attributes.link.nodeValue);
    		if (evt.target.classList.contains('add_film_link')) {
    			evt.target.classList.remove('add_film_link');
    			evt.target.classList.add('remove_film_link');
    			evt.target.innerHTML = 'Убрать';
    			programLinkFilm(evt.target.attributes.filmid.nodeValue, 'POST');
    			evt.target.parentNode.parentNode.children[1].classList.add('filmInCurrentProgram');
    			// evt.target.parentNode[1].classList.remove('filmInCurrentProgram');

    		} else {
    			evt.target.classList.remove('remove_film_link');
    			evt.target.classList.add('add_film_link');
    			evt.target.innerHTML = 'Добавить';
    			evt.target.parentNode.parentNode.children[1].classList.remove('filmInCurrentProgram');
    			programLinkFilm(evt.target.attributes.filmid.nodeValue, 'DELETE');
    		}
    	}
    }
});

cardSearchAddFilmSwitherFree.addEventListener('click', function (evt) {
	searchFilmsInList();
});

function programLinkFilm (filmID, TypeMethod) {
	xhr.request = {
	    metod: TypeMethod,
	    url: `filmPrograms/${curProgramID}/film/${filmID}`,
	    data: '',
	    callbackSuccess: onSuccessLoadAllData
	 };
	 //

}

selectTimeZone.addEventListener('change', function (evt) {
	reDisplayMainTable();
});



function initFirstSetup() {

  tools.removeOptions(selectTimeZone);
  for (let i = -11; i < 12; i++) {
    let opt = document.createElement('option');
    opt.value = i;
    
    if(i > 0)
      opt.innerHTML = '+'+i;
    else
      opt.innerHTML = i;
    
    if(i == 3)
      opt.innerHTML += ' (MOSCOW)';

    selectTimeZone.appendChild(opt);
  }
   xhr.request = {
      metod: 'GET',
      url: `festival/${auth.currentFestival}/scheduleInfo`,
      data: '',
      callbackSuccess: onSuccessFestInfo
    };
}

const onSuccessFestInfo = (servarAnswer) => {
  if (servarAnswer.status === 200) 
    selectTimeZone.value = servarAnswer.data.tTimeZone;
};

function openCardProgram(programid) {
	
	curProgramID = programid;

	xhr.request = {
	    metod: 'GET',
	    url: `filmPrograms/${programid}`,
	    data: '',
	    callbackSuccess: onSuccessLoadOneProgram
	 };
}



const onSuccessLoadOneProgram = (servarAnswer) => {

  if (servarAnswer.status === 200){
		 	programsMarkup.drawDataInOneCard(servarAnswer.data);
		 	$(cardOne).modal('show');
	}
};




export default {

  start(){
    // makeExport();

    initFirstSetup();
    document.querySelector('#MenuProgrammsOfFilms').addEventListener('click', loadListFilms);
  },

  publicoOenCardProgram(pID){
  	openCardProgram(pID);
  },

  stop() {
    // pointsMarkup.cleanContainer();
    document.querySelector('#MenuProgrammsOfFilms').removeEventListener('click', loadListFilms);
  }
};
